import React, { Component } from "react";

import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import AdmissionContext from "../AdmissionContext";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import {
  ShowInvalidEmailFormat,
  ShowRequiredField,
  kPButton,
  AverageFamilyIncome,
} from "../global";
import isEmail from "validator/lib/isEmail";

class ContactView extends Component {
  static contextType = AdmissionContext;

  textfieldValueChanged = (index, event) => {
    const { contact } = this.context;
    contact.required = false;

    if (index === 0) {
      contact.email = event.target.value;
    } else if (index === 1) {
      contact.mobileno = event.target.value;
    } else if (index === 2) {
      contact.fathersName = event.target.value;
    } else if (index === 3) {
      contact.fathersOccupation = event.target.value;
    } else if (index === 4) {
      contact.fathersAddress = event.target.value;
    } else if (index === 5) {
      contact.fathersContactNo = event.target.value;
    } else if (index === 6) {
      contact.mothersName = event.target.value;
    } else if (index === 7) {
      contact.mothersOccupation = event.target.value;
    } else if (index === 8) {
      contact.mothersAddress = event.target.value;
    } else if (index === 9) {
      contact.mothersContactNo = event.target.value;
    } else if (index === 10) {
      contact.guardianName = event.target.value;
    } else if (index === 11) {
      contact.guardianRelationship = event.target.value;
    } else if (index === 12) {
      contact.guardianAddress = event.target.value;
    } else if (index === 13) {
      contact.guardianOccupation = event.target.value;
    } else if (index === 14) {
      contact.guardianContactNo = event.target.value;
    }

    this.context.SetContact(contact);
  };

  checkRequireFields = (index) => {
    const { contact, studentType } = this.context;

    if (contact.required) {
      if (index === 0) {
        if (contact.email === "") {
          return ShowRequiredField("Email");
        } else {
          if (!isEmail(contact.email)) {
            return ShowInvalidEmailFormat();
          }
        }
      } else if (index === 1) {
        if (contact.mobileno === "") {
          return ShowRequiredField("Mobile No.");
        }
      } else if (index === 2) {
        if (contact.fathersName === "") {
          return ShowRequiredField("Name");
        }
      } else if (index === 3) {
        if (contact.fathersOccupation === "") {
          return ShowRequiredField("Occupation");
        }
      } else if (index === 4) {
        if (contact.fathersAddress === "") {
          return ShowRequiredField("Company & Address");
        }
      } else if (index === 5) {
        if (contact.fathersContactNo === "") {
          return ShowRequiredField("Contact No.");
        }
      } else if (index === 6) {
        if (contact.mothersName === "") {
          return ShowRequiredField("Name");
        }
      } else if (index === 7) {
        if (contact.mothersOccupation === "") {
          return ShowRequiredField("Occupation");
        }
      } else if (index === 8) {
        if (contact.mothersAddress === "") {
          return ShowRequiredField("Company & Address");
        }
      } else if (index === 9) {
        if (contact.mothersContactNo === "") {
          return ShowRequiredField("Contact No.");
        }
      } else if (index === 10) {
        if (contact.guardianName === "") {
          return ShowRequiredField("Name");
        }
      } else if (index === 11) {
        if (contact.guardianRelationship === "") {
          return ShowRequiredField("Relationship");
        }
      } else if (index === 12) {
        if (contact.guardianAddress === "") {
          return ShowRequiredField("Address");
        }
      } else if (index === 13) {
        if (contact.guardianOccupation === "") {
          return ShowRequiredField("Occupation");
        }
      } else if (index === 14) {
        if (contact.guardianContactNo === "") {
          return ShowRequiredField("Contact No.");
        }
      } else if (index === 15) {
        if (studentType.academic.description.toLowerCase() === "undergraduate") {
          console.log(contact.averageFamilyIncome)
          if (contact.averageFamilyIncome === null) {
            return ShowRequiredField("Income");
          }
        }        
      }
    }

    return null;
  };

  averageFamilyIncomeValueChanged = (event, value) => {
    const { contact } = this.context;
    contact.required = false;
    contact.averageFamilyIncome = value;
    this.context.SetContact(contact);
  };

  backButtonClicked = () => {
    this.context.btnBackClicked();
  };

  nextButtonClicked = () => {
    const { contact, studentType } = this.context;

    if (studentType.academic.description.toLowerCase() === "undergraduate") {
      if (contact.averageFamilyIncome === null) {
        contact.required = true;
        this.context.SetContact(contact);
        return;
      }
    }   

    if (
      contact.email === "" ||
      contact.mobileno === "" ||
      contact.fathersName === "" ||
      contact.fathersOccupation === "" ||
      contact.fathersAddress === "" ||
      contact.fathersContactNo === "" ||
      contact.mothersName === "" ||
      contact.mothersOccupation === "" ||
      contact.mothersAddress === "" ||
      contact.mothersContactNo === "" ||
      contact.guardianName === "" ||
      contact.guardianRelationship === "" ||
      contact.guardianAddress === "" ||
      contact.guardianOccupation === "" ||
      contact.guardianContactNo === ""
    ) {
      contact.required = true;
      this.context.SetContact(contact);
    } else {
      this.context.btnNextClicked();
    }
  };

  render() {
    const { contact } = this.context;

    return (
      <Box display="flex" justifyContent="center" pt={2}>
        <Grid container spacing={1}>
          <Grid item xs={1} sm={2} lg={3}></Grid>
          <Grid item xs={10} sm={8} lg={6}>
            <Card
              style={{
                border: 0,
                // minWidth: 500,
                // maxWidth: 600,
              }}
              variant="outlined"
            >
              <CardContent>
                <Typography component="div">
                  <Box
                    fontWeight={500}
                    fontSize={18}
                    color="#388e3c"
                    display="flex"
                    justifyContent="flex-start"
                  >
                    Contact
                  </Box>
                </Typography>

                <Box pt={2}>
                  <TextField
                    fullWidth={true}
                    id="txtEmail"
                    label="Email"
                    variant="outlined"
                    value={contact.email}
                    onChange={(e) => {
                      this.textfieldValueChanged(0, e);
                    }}
                  />
                </Box>
                {/* email */}
                {this.checkRequireFields(0)}

                <Box pt={2}>
                  <TextField
                    fullWidth={true}
                    id="txtMobileNo"
                    label="Mobile No."
                    variant="outlined"
                    value={contact.mobileno}
                    onChange={(e) => {
                      this.textfieldValueChanged(1, e);
                    }}
                  />
                </Box>

                {/* mobileno */}
                {this.checkRequireFields(1)}

                {/* FATHERS     */}

                <Typography component="div">
                  <Box
                    fontWeight={500}
                    fontSize={18}
                    color="#388e3c"
                    display="flex"
                    justifyContent="flex-start"
                    pt={3}
                  >
                    Father
                  </Box>
                </Typography>

                <Box pt={2}>
                  <TextField
                    fullWidth={true}
                    id="txtfathersName"
                    label="Name"
                    variant="outlined"
                    value={contact.fathersName}
                    onChange={(e) => {
                      this.textfieldValueChanged(2, e);
                    }}
                  />
                </Box>

                {/* fathersName */}
                {this.checkRequireFields(2)}

                <Box pt={2}>
                  <TextField
                    fullWidth={true}
                    id="txtfathersOccupation"
                    label="Occupation"
                    variant="outlined"
                    value={contact.fathersOccupation}
                    onChange={(e) => {
                      this.textfieldValueChanged(3, e);
                    }}
                  />
                </Box>

                {/* fathersOccupation */}
                {this.checkRequireFields(3)}

                <Box pt={2}>
                  <TextField
                    fullWidth={true}
                    id="txtfathersAddress"
                    label="Company & Address"
                    variant="outlined"
                    value={contact.fathersAddress}
                    onChange={(e) => {
                      this.textfieldValueChanged(4, e);
                    }}
                  />
                </Box>

                {/* fathersAddress */}
                {this.checkRequireFields(4)}

                <Box pt={2}>
                  <TextField
                    fullWidth={true}
                    id="txtfathersContactNo"
                    label="Contact No"
                    variant="outlined"
                    value={contact.fathersContactNo}
                    onChange={(e) => {
                      this.textfieldValueChanged(5, e);
                    }}
                  />
                </Box>

                {/* fathersContactNo */}
                {this.checkRequireFields(5)}

                {/* MOTHERS     */}

                <Typography component="div">
                  <Box
                    fontWeight={500}
                    fontSize={18}
                    color="#388e3c"
                    display="flex"
                    justifyContent="flex-start"
                    pt={3}
                  >
                    Mother
                  </Box>
                </Typography>

                <Box pt={2}>
                  <TextField
                    fullWidth={true}
                    id="txtmothersName"
                    label="Name"
                    variant="outlined"
                    value={contact.mothersName}
                    onChange={(e) => {
                      this.textfieldValueChanged(6, e);
                    }}
                  />
                </Box>

                {/* mothersName */}
                {this.checkRequireFields(6)}

                <Box pt={2}>
                  <TextField
                    fullWidth={true}
                    id="txtmothersOccupation"
                    label="Occupation"
                    variant="outlined"
                    value={contact.mothersOccupation}
                    onChange={(e) => {
                      this.textfieldValueChanged(7, e);
                    }}
                  />
                </Box>

                {/* mothersOccupation */}
                {this.checkRequireFields(7)}

                <Box pt={2}>
                  <TextField
                    fullWidth={true}
                    id="txtmothersAddress"
                    label="Company & Address"
                    variant="outlined"
                    value={contact.mothersAddress}
                    onChange={(e) => {
                      this.textfieldValueChanged(8, e);
                    }}
                  />
                </Box>

                {/* mothersAddress */}
                {this.checkRequireFields(8)}

                <Box pt={2}>
                  <TextField
                    fullWidth={true}
                    id="txtmothersContactNo"
                    label="Contact No"
                    variant="outlined"
                    value={contact.mothersContactNo}
                    onChange={(e) => {
                      this.textfieldValueChanged(9, e);
                    }}
                  />
                </Box>

                {/* mothersContactNo */}
                {this.checkRequireFields(9)}

                {/* GUARDIAN     */}

                <Typography component="div">
                  <Box
                    fontWeight={500}
                    fontSize={18}
                    color="#388e3c"
                    display="flex"
                    justifyContent="flex-start"
                    pt={3}
                  >
                    Guardian
                  </Box>
                </Typography>

                <Box pt={2}>
                  <TextField
                    fullWidth={true}
                    id="guardianName"
                    label="Name"
                    variant="outlined"
                    value={contact.guardianName}
                    onChange={(e) => {
                      this.textfieldValueChanged(10, e);
                    }}
                  />
                </Box>

                {/* guardianName */}
                {this.checkRequireFields(10)}

                <Box pt={2}>
                  <TextField
                    fullWidth={true}
                    id="guardianRelationship"
                    label="Relationship"
                    variant="outlined"
                    value={contact.guardianRelationship}
                    onChange={(e) => {
                      this.textfieldValueChanged(11, e);
                    }}
                  />
                </Box>

                {/* guardianRelationship */}
                {this.checkRequireFields(11)}

                <Box pt={2}>
                  <TextField
                    fullWidth={true}
                    id="guardianAddress"
                    label="Address"
                    variant="outlined"
                    value={contact.guardianAddress}
                    onChange={(e) => {
                      this.textfieldValueChanged(12, e);
                    }}
                  />
                </Box>

                {/* guardianAddress */}
                {this.checkRequireFields(12)}

                <Box pt={2}>
                  <TextField
                    fullWidth={true}
                    id="guardianOccupation"
                    label="Occupation"
                    variant="outlined"
                    value={contact.guardianOccupation}
                    onChange={(e) => {
                      this.textfieldValueChanged(13, e);
                    }}
                  />
                </Box>

                {/* guardianOccupation */}
                {this.checkRequireFields(13)}

                <Box pt={2}>
                  <TextField
                    fullWidth={true}
                    id="txtguardianContactNo"
                    label="Contact No"
                    variant="outlined"
                    value={contact.guardianContactNo}
                    onChange={(e) => {
                      this.textfieldValueChanged(14, e);
                    }}
                  />
                </Box>

                {/* guardianContactNo */}
                {this.checkRequireFields(14)}

                {this.showFamilyAverageIncome()}

                <Box
                  justifyContent="center"
                  display="flex"
                  pt={3}
                  fontSize={14}
                >
                  <Box width={200} justifyContent="flex-start">
                    <Button
                      fullWidth={true}
                      style={kPButton}
                      variant="contained"
                      onClick={() => {
                        this.backButtonClicked();
                      }}
                    >
                      Back
                    </Button>
                  </Box>

                  <Box width={200} minHeight={100} pl={2}>
                    <Button
                      fullWidth={true}
                      style={kPButton}
                      variant="contained"
                      onClick={() => {
                        this.nextButtonClicked();
                      }}
                    >
                      Next
                    </Button>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={1} sm={2} lg={3}></Grid>
        </Grid>
      </Box>
    );
  }

  showFamilyAverageIncome = () => {
    const { contact, studentType } = this.context;
    if (studentType.academic.description.toLowerCase() === "undergraduate") {
      return (
        <Box>
          <Typography component="div">
            <Box
              fontWeight={500}
              fontSize={18}
              color="#388e3c"
              display="flex"
              justifyContent="flex-start"
              pt={3}
            >
              Average Family Income
            </Box>
          </Typography>

          <Box pt={2}>
            <Autocomplete
              id="cboAverageFamilyIncome"
              options={AverageFamilyIncome}
              getOptionLabel={(item) => item.description}
              fullWidth={true}
              onChange={this.averageFamilyIncomeValueChanged}
              value={contact.averageFamilyIncome}
              renderInput={(params) => (
                <TextField {...params} label="Income" variant="outlined" />
              )}
            />
          </Box>
          {this.checkRequireFields(15)}

        </Box>
      );
    }
  };
}

export default ContactView;
